import moment from 'moment';
import { SELLING_PLATFORM_OPTIONS } from '../constants';

import { volumeGraphPointColorForLabel } from './graphs.util';

export function getIndustryData(industry, dashboard) {
  const response = {
    dailyVolume: {
      graphValues: { label: 'Daily Volume', data: {}, pointColors: {} },
    },
    monthlyVolume: {
      graphValues: { label: 'Monthly Volume', data: {}, pointColors: {} },
    },
    monthlySales: {
      graphValues: { label: 'Monthly Sales Count', data: {}, pointColors: {} },
    },
    dailySales: {
      graphValues: { label: 'Daily Sales Count', data: {}, pointColors: {} },
    },
    dailyVerifiedVolume: {
      graphValues: { label: 'Daily Verified Volume', data: {}, pointColors: {} },
    },
    monthlyVerifiedVolume: {
      graphValues: { label: 'Monthly Verified Volume', data: {}, pointColors: {} },
    },
  };

  if (industry && industry.dailyVolumeTotal) {
    Object.keys(industry.dailyVolumeTotal).forEach((dailyKey) => {
      const pointColor = volumeGraphPointColorForLabel(dailyKey);

      response.dailyVolume.graphValues.data[dailyKey] = industry.dailyVolumeTotal[dailyKey].p;
      response.dailySales.graphValues.data[dailyKey] = industry.dailyVolumeTotal[dailyKey].n;
      response.dailyVolume.graphValues.pointColors[dailyKey] = pointColor;
      response.dailySales.graphValues.pointColors[dailyKey] = pointColor;

      const monthlyKey = dailyKey.slice(0, 2) + '/01' + dailyKey.slice(5, 10);

      if (monthlyKey !== moment().format('MM/01/YYYY')) {
        response.monthlyVolume.graphValues.pointColors[dailyKey] = pointColor;
        response.monthlySales.graphValues.pointColors[dailyKey] = pointColor;

        if (response.monthlyVolume.graphValues.data[monthlyKey]) {
          response.monthlyVolume.graphValues.data[monthlyKey] = response.monthlyVolume.graphValues.data[monthlyKey] + industry.dailyVolumeTotal[dailyKey].p;
          response.monthlySales.graphValues.data[monthlyKey] = response.monthlySales.graphValues.data[monthlyKey] + industry.dailyVolumeTotal[dailyKey].n;
        } else {
          response.monthlyVolume.graphValues.data[monthlyKey] = industry.dailyVolumeTotal[dailyKey].p;
          response.monthlySales.graphValues.data[monthlyKey] = industry.dailyVolumeTotal[dailyKey].n;
        }
      }
    });
  }

  if (industry && industry.platformMonth && industry.platformVolume) {
    response.monthlyVolume.platformMonth = industry.platformMonth;
    response.monthlyVolume.platforms = Object.keys(industry.platformVolume)
      .filter((platform) => platform === 'Fanatics' || SELLING_PLATFORM_OPTIONS.find((option) => option.value === platform))
      .map((platform) => {
        return {
          label: platform === 'Fanatics' ? 'Fanatics' : SELLING_PLATFORM_OPTIONS.find((option) => option.value === platform).label,
          value: industry.platformVolume[platform],
        };
      })
      .sort((a, b) => {
        return b.value - a.value;
      })
      .slice(0, 5);
  }

  if (dashboard && dashboard.dailySalesTotal) {
    Object.keys(dashboard.dailySalesTotal).forEach((dailyKey) => {
      const pointColor = volumeGraphPointColorForLabel(dailyKey);

      response.dailyVerifiedVolume.graphValues.data[dailyKey] = dashboard.dailySalesTotal[dailyKey];
      response.dailyVerifiedVolume.graphValues.pointColors[dailyKey] = pointColor;

      const monthlyKey = dailyKey.slice(0, 2) + '/01' + dailyKey.slice(5, 10);

      if (monthlyKey !== moment().format('MM/01/YYYY')) {
        response.monthlyVerifiedVolume.graphValues.pointColors[dailyKey] = pointColor;

        if (response.monthlyVerifiedVolume.graphValues.data[monthlyKey]) {
          response.monthlyVerifiedVolume.graphValues.data[monthlyKey] = response.monthlyVerifiedVolume.graphValues.data[monthlyKey] + dashboard.dailySalesTotal[dailyKey];
        } else {
          response.monthlyVerifiedVolume.graphValues.data[monthlyKey] = dashboard.dailySalesTotal[dailyKey];
        }
      }
    });
  }

  return response;
}
